import contact from './contact';
import contacts from './contacts';
import sharewallets from './sharewallets';

export default [contacts, sharewallets, contact];
